// extracted by mini-css-extract-plugin
module.exports = {"header-label":"styles-module__header-label___3A0ws","header-value":"styles-module__header-value___2yPZG"};